import { Flex, FlexProps, IconButton, IconButtonProps } from '@chakra-ui/react';
import { ArrowLeft, Close } from '../Icons';
import { useWizard } from './useWizard';

export interface WizardHeaderProps extends FlexProps {
  onClose: () => void;
}

export const WizardHeader = ({
  onClose,
  children,
  ...props
}: WizardHeaderProps) => {
  const [{ currentStep, totalSteps, context }, { previous }] = useWizard();

  const { isPreviousEnabled } = context;

  return (
    <Flex
      bg="white"
      px={4}
      textStyle="body-normal-medium"
      height={16}
      {...props}
      align="center"
      boxShadow="borderBottom"
      justify="space-between"
      left={0}
      position="fixed"
      right={0}
      top={0}
      w="100%"
      zIndex="docked"
    >
      <WizardHeaderButton
        aria-label="Previous"
        icon={<ArrowLeft boxSize={6} />}
        onClick={previous}
        visibility={!isPreviousEnabled ? 'hidden' : undefined}
      />
      {children || `Step ${currentStep} of ${totalSteps}`}
      <WizardHeaderButton
        aria-label="Close"
        icon={<Close boxSize={6} />}
        onClick={onClose}
      />
    </Flex>
  );
};

const WizardHeaderButton = (props: IconButtonProps) => (
  <IconButton {...props} variant="unstyled" boxSize={10} />
);
